<template>
    <div class="automation-action-settings">
        <div class="field">
            <label>{{ t('automations-form-actions-web_hook-url_label') }}</label>
            <input type="url" class="form-control" v-model="url" />
        </div>
        <div class="webhook-body">
            <h2>{{ t('automations-form-actions-web_hook-request_body_title') }}</h2>

            <table
                v-for="(field, index) in fields"
                :key="'field-' + index"
                class="field-table"
            >
                <tr>
                    <td>
                        <label>{{ t('automations-form-actions-web_hook-field_key_label') }}</label>
                    </td>
                    <td>
                        <input
                            type="text"
                            v-model="fields[index]['key']"
                            class="form-control"
                            :placeholder="t('automations-form-actions-web_hook-field_key_placeholder')"
                        />
                    </td>
                </tr>
                <tr>
                    <td><label>{{ t('automations-form-actions-web_hook-field_value_label') }}</label></td>
                    <td>
                        <input
                            type="text"
                            v-model="fields[index]['value']"
                            class="form-control"
                            :placeholder="t('automations-form-actions-web_hook-field_value_placeholder')"
                        />
                    </td>
                </tr>
            </table>
            <button class="btn btn-primary" @click.prevent="addField">
                {{ t('automations-form-actions-web_hook-add_field_button') }}
            </button>
        </div>
    </div>
</template>
<style scoped lang="scss">
.field-table {
    width: 100%;
    border-bottom: 1px solid #ccc;
    margin-bottom: 10px;

    td {
        padding: 0 0 10px;
    }
}
</style>
<script>
export default {
    props: {
        properties: Object,
        conditions: Array,
    },
    data: function () {
        return {
            title: this.t("automations-form-actions-web_hook-title"),
            description: this.t("automations-form-actions-web_hook-description"),
            url: this.properties.url ? this.properties.url : 0,
            fields: this.properties.fields ? [...this.properties.fields] : [],
        };
    },
    mounted: function () {
        this.$emit("mounted", this);
    },

    methods: {
        t(term, replaces) {
            return this.$root.t(term, replaces);
        },
        changed: function () {
            this.$emit("propertiesUpdated", {
                url: this.url,
                fields: this.fields,
            });
        },
        addField() {
            this.fields.push({
                key: "",
                value: "",
            });
        },

        isValid: function () {
            return this.url !== "";
        },
    },
    watch: {
        properties: function () {
            this.url = this.properties.url;
            if (
                JSON.stringify(this.properties.fields) !==
                JSON.stringify(this.fields)
            ) {
                this.fields = this.properties.fields
                    ? [...this.properties.fields]
                    : [];
            }
        },
        url: function () {
            this.changed();
        },
        fields: {
            deep: true,
            handler() {
                this.changed();
            },
        },
    },
};
</script>
